/* eslint @typescript-eslint/no-explicit-any: 0 */

import Serializer from "./Serializer";
import TagSerializer from "./TagSerializer";
import { Question } from "../../../app/types/Question";
import { newUser } from "../../../app/types/User";

class QuestionSerializer extends Serializer<Question> {
    private tagSerializer: TagSerializer;

    constructor() {
        super();
        this.tagSerializer = new TagSerializer();
    }

    public serialize(question: Partial<Question>) {
        return {
            title: question.title,
            body: question.body,
            tags: question.tags?.map((tag) => tag.id) ?? undefined,
            accepted_answer: question.acceptedAnswer === -1 ? undefined : question.acceptedAnswer,
        };
    }

    public deserialize(data: any): Question {
        return {
            id: data.id,
            title: data.title,
            body: data.body,
            author: newUser(data.user.id, data.user.username),
            createdAt: new Date(data.timestamp).toLocaleString(),
            updatedAt: new Date(data.updated).toLocaleString(),
            votes: data.votes,
            userVote: data.current_user_vote,
            answersCount: data.answers_count,
            acceptedAnswer: data.accepted_answer ?? -1,
            views: data.views,
            tags: this.tagSerializer.deserializeList(data.tags),
            comments: [],
        };
    }
}

export default QuestionSerializer;
